import React, { Component } from 'react'
import TInput from '../component/tinput'
import TButton from '../component/tbutton'
import TSection from '../component/tsection'
import { ruleRunner, run } from '../component/validation/rulerunner'
import { required, emailCheck } from '../component/validation/rules.js'
import { getParameterByName, postnummerCheck } from '../component/functions'
import 'babel-polyfill'

const fieldValidations = [
    ruleRunner('email', 'Email', emailCheck),
    ruleRunner('fornavn', 'Fornavn', required),
    ruleRunner('efternavn', 'Efternavn', required),
    ruleRunner('postnummer', 'Postnummer', required),
    ruleRunner('eventskonkurrencer', 'Events og konkurrencer', required),
    ruleRunner('nyhedsbrev', 'Nyhedsbrev', required)
]

const Postnummer = class Postnummer extends Component {
    state = {
        form: 'tilmeld',
        showErrors: false,
        validationErrors: {},
        disctrictId: ''
    }

    inputChange = async t => {
        const inputName = t.target.name
        let newState = {
            ...this.state,
            [inputName]: t.target.value
        }
        newState.validationErrors = await run(newState, fieldValidations)
        this.setState(newState, () => {
            if (this.state.postnummer && this.state.postnummer.length > 0) {
                let pcheck = postnummerCheck(this.state.postnummer)
                pcheck.then(data => {
                    if (data === false) {
                        let newState = {
                            ...this.state,
                            validationErrors: {
                                ...this.state.validationErrors,
                                postnummer: 'Postnummer findes ikke i database'
                            }
                        }
                        this.setState(newState)
                    } else {
                        if (
                            this.state.validationErrors &&
                            this.state.validationErrors.postnummer
                        )
                            delete this.state.validationErrors.postnummer
                        this.setState({ disctrictId: data })
                    }
                })
            }
        })
    }
    submitForm = e => {
        e.preventDefault()
        // recheck postnummer
        if (
            this.state &&
            this.state.postnummer &&
            this.state.postnummer.length > 0
        ) {
            let pcheck = postnummerCheck(this.state.postnummer)
            pcheck.then(data => {
                if (data === false) {
                    let newState = {
                        ...this.state,
                        validationErrors: {
                            ...this.state.validationErrors,
                            postnummer: 'Postnummer findes ikke i database'
                        }
                    }
                    this.setState(newState, () => this.submitData())
                } else {
                    let newState = { ...this.state }
                    if (
                        newState.validationErrors &&
                        newState.validationErrors.postnummer
                    ) {
                        delete newState.validationErrors.postnummer
                        this.setState({
                            newState
                        })
                    }
                    this.submitData()
                }
            })
        } else {
            this.submitData()
        }
    }

    submitData = () => {
        if (
            Object.keys(this.state.validationErrors).length === 0 &&
            this.state.email &&
            this.state.fornavn &&
            this.state.efternavn &&
            this.state.postnummer &&
            this.state.eventskonkurrencer &&
            this.state.nyhedsbrev
        ) {
            // submit to responsys
            // https://www.toyota.dk/forms/e-newsletter?campaign=Facebook%3A%20permission_Maj_Burst1_mailliste
            let c = getParameterByName('campaign')
            let campaignText = 'web formular: GDPR_lykkehjul'
            if (c === 'Facebook: permission_Maj_Burst1_mailliste') {
                campaignText = c
            }
            if (c === 'Facebook: Permission_Maj_Burst1_Lookalike/bred') {
                campaignText = c
            }
            if (c === 'Facebook: Permission_Maj_Burst2_mailliste') {
                campaignText = c
            }
            if (c === 'Facebook: Permission_Maj_Burst2_Lookalike/bred') {
                campaignText = c
            }

            let url =
                'https://news.toyota.dk/pub/rf?_ri_=X0Gzc2X=AQpglLjHJlCQGrzah6eyzaOzecJKwEArawnjKwXc6MnzcXDFVwjpnpgHlpgneHmgJoXX0Gzc2X=AQpglLjHJlCQGnj6P0tvcUoUHLWIzfbs2qfyIvezbfMLDa&_ei_=EtKRh-XMe64J-mhCNQecGSQ&_di_=h2fjtsithfpk8bgaphspr6o0l2r9ueu5890p5locf3jk0le9dmug&'
            let query = `EMAIL_ADDRESS_=${this.state.email}&FIRSTNAME=${
                this.state.fornavn
            }&LASTNAME=${
                this.state.efternavn
            }&PERMISSION_REMINDERS=&PERMISSION_NEWS_AND_OFFERS=${
                this.state.nyhedsbrev
            }&PERMISSION_SURVEY=&PERMISSION_EVENT_COMPETITION=${
                this.state.eventskonkurrencer
            }&SIGNUP_SOURCE=toyota.dk&SIGNUP_PERMISSION_VERSION=2018-01&SIGNUP_CAMPAIGN=${campaignText}&signup_id=${Date.now()}&SIGNUP_TYPE=custom&POSTAL_CODE_=${
                this.state.postnummer
            }&DISTRICT=${this.state.disctrictId}`

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: query
            }).then(this.setState({ form: 'tak' }))
        } else {
            let valErr = {}
            if (!this.state.email) valErr.email = 'email skal udfyldes'
            if (!this.state.fornavn) valErr.fornavn = 'fornavn skal udfyldes'
            if (!this.state.efternavn)
                valErr.efternavn = 'efternavn skal udfyldes'
            if (!this.state.postnummer)
                valErr.postnummer = 'efternavn skal udfyldes'
            if (!this.state.eventskonkurrencer)
                valErr.eventskonkurrencer =
                    'Events og konkurrencer skal udfyldes'
            if (!this.state.nyhedsbrev)
                valErr.nyhedsbrev = 'Nyhedsbrev og konkurrencer skal udfyldes'
            if (
                this.state.validationErrors &&
                this.state.validationErrors.postnummer
            )
                valErr.postnummer = 'Postnummer findes ikke i database'
            this.setState({ showErrors: true, validationErrors: valErr })
        }
    }
    componentWillMount() {
        if (getParameterByName('Step') === '3')
            this.setState({ form: 'step-3' })
    }
    render() {
        return (
            <div>
                <form
                    onSubmit={this.submitForm}
                    className={`${this.state.form === 'tilmeld' && 'show'}`}
                >
                    <div className="up-to-date">
                        <div>
                            Tak for din tilmelding, indtast postnummer.
                        </div>
                        
                        <TInput
                            onChange={this.inputChange}
                            name="postnummer"
                            placeholder="Postnummer (påkrævet)"
                            type="number"
                            valid={
                                this.state.showErrors &&
                                this.state.validationErrors['postnummer']
                                    ? 'false'
                                    : undefined
                            }
                        />
                        
                        <div className="center margin">
                            <TButton
                                value="TILMELD"
                                onClick={this.submitForm}
                            />
                        </div>
                    </div>
                </form>
                <form className={`${this.state.form === 'tak' && 'show'}`}>
                    <div className="up-to-date">
                        <div className="center">
                            <img
                                src="data:image/png;base64,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"
                                className="top-image"
                                alt=""
                            />
                        </div>
                        <div className="center">
                            <h2>Tjek din indbakke</h2>
                            Vi har sendt dig en e-mail! Klik på linket i mailen
                            for at bekræfte, at du vil modtage tilbud og nyheder
                            fra Toyota – så kommer du videre til lykkehjulet.
                            Måske bliver du en af de heldige vindere af
                            biografbilletter eller gavekort til tankstation.
                        </div>
                    </div>
                </form>
                <form
                    className={`${this.state.form === 'step-3' && 'show'}`}
                    onSubmit={e => {
                        e.preventDefault()
                    }}
                >
                    <div className="up-to-date">
                        <div className="center">
                            <img
                                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABPCAMAAAA5gNBnAAABTVBMVEUAAAAdLDYdLTYdLTYdLTYdLTYdLTYdLTYdLTYdLTYdLTYdLTYdLDYdLTYdLTYdLTYdLTYdLTYdLTb19fX////o6ekdLDbjAAuxtrmCio+orrG4vcCJkJUsOkMhMDooNkAfLjglMz3z8/R+hovwd33U1td3gIZMIixOWmE/S1QwPkfm5+fi4+Sdo6c5Rk/eAQzP0tS9wcPs7O21ur2RmJ2Mk5iEi5Bye4FrdHtVYGg2Q0zd3+BhbHNaZWxKVl1DUFjqREzv8PHa3N3Iy83DxsmssbSHj5ReaG9GU1toHCa5CRTRBA/k5ebX2duHFR/GBxH6+vrn6Oje4OKiqKyZoKRncHczQUrTBA7V2NnKzc/AxMezCxWwtLiorbClq66Um6CPlZo3JzD4u77nHCa2ChXsVVw2JzE6JjBTISrZAg32qq7yiI3uZm2IFR/HBhGuxhn9AAAAE3RSTlMA/vrqJJv1iQwIyFfy0c+YMiNYta6Z4QAABPdJREFUaN692Odf2kAcx3EDdbR2X++LqUmARFYYshQQhKIyrGLdVevo3u3//7B39lVDBBTI0c8zXyjvjF+Ow7HRNDX96J7b5XLfezQ9NTba7oxP4KqJ8Ttjo+vupAtSaOvNxvz8xsetkATX5N2xEfXkIaT1V56rXq1LeDiik3vsxpeXHlsvP8P9eGwE3XHj6zfPtV6H4B7Bud19iNC8p6P5EB6Iv2+T+Pza06XX7zAp2nrikqz79XNu7oV13ySX6As5jnXrbL4/ezZn/bSOcbHW1ITUNvNzNuyVNCF2LZlGyNMdY4UwPXYfItuyY588VlvsOkJob+zYC4/VG9y7xMqzYvJioze2ATfDEsABeSYiDfO9sXm4GFZrAGX6n7AZ3QCWjgRg5u2XcYaQuA/elHMsbBuQF+/fezoGhGFk1g9f3DEW5KNv9eGD5/roM4yVVAHDKTaDUO/LyB9qjvGKCaChO8N0b/ty9d62gvxmy9UVRmgZqGw60/LtC/EPtoLYF2ILI+llwEw6sZIqpJdtE/LBY/+IsTCm5X3wZ4a3Mn5IeNf7w9OGEWr4gYthrQvAH6z03hbYMabVVSC3PQy1nQPUOm2ZPTc8dowVXUgAhergVrUAJBaihBybnVu5d3wrZ2GWlm0Ckd1Brd0I0MxGCatV6dykPmDnZWFWsWwBUI8Hs45VoJCNkcuqssa33x8vt9+/rO13J8a1Aw1abRCrxv7ggFn/Osr5wbO+WPTCSPFtzgso/VsK4M29LZK20rVcBOBfmZ5OMaQ3xjTDBPLbfY5hHjANZl1rBrCU3hhZWViMAOF0P1Y6DEQWF1bIsBjT6mUgsXK7tZIAynVmDY+RwIKyLMF7cpt14oW0rCwEiBOMa3kNvr2brT0ftDy3nGEkqShBLyDfZMmAN6goSeIU45pxCJRIL4qUgEODW84xsqoofCibtLtFm3wMFWWViMC4poSBw0A3K3AIhBVuicHIGnuzkg/+2U6Lb8dK7OU1IgCztDx72/3r1j47hLxlCcFISmFDqQLBbdsKFQTUIHspRQRhliYvActVy+I7oyXZsoRhJKOwoVSBpZOr22UCKhtDJUNEY3qGnxnvoMWpoxJY/MwyumiMafsq0GxoAMKyHAagNZqAus8s4ViKWQVZNiISLpMihiwXmJYSj+1p8AdlnhFWNU0NM4oV9EPbE4zpi4B5Et2Tr7UXPTGBRV0kli4BlQCl0bjdikcpDVSAUlocFisDy7uUtRm3WZuUtbsMlGOisOQSEIxSFtPOLeucWbxoEFhKisEyXvgu6L92Mot/qcXMDv3XhQ/ejAhsn73RKW0rEOdWPEDbOmUHtO8Y0/klWqX2Yq1WjNpb5Zdad4al+c0/on10xIco7QQr8rGO0b6K8cejODy2agLGDu2zHQMwV4fFTv3Q4nSA4hr8p8NhWUCdpQM1qwLZIbBqDkgc0wE7TgC56qDYTgEIr9CBWwkDhZ3BsFYEyG/SIdrMA5HWINiaCtTpkNUBda1/7IxN1TkdunM2xWd9YnodMFPUQSkTqOv9YNUDIJKkjkpGgIPq7ViMj1OROqzIhzl2GxbgD0qUOi7KH9PAzVjKC1+WCinL/7l9ExZnv1CjgqqxA4/3xHQDOFyjwlo7BAy9O1ZrAM0AFVigCTRqXbEE0NilQtttAIluGKty9lxwZxWgGza6OrH7GFn3r1t/AMGHfVGzMi7VAAAAAElFTkSuQmCC"
                                className="top-image"
                                alt=""
                            />
                        </div>
                        <div className="center">
                            <h2>
                                Tak for din opdatering<br />
                            </h2>
                            
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default Postnummer



// WEBPACK FOOTER //
// ./src/feature/postnummer.js